// extracted by mini-css-extract-plugin
export var active = "_v-8";
export var addWidgetButton = "_v-9";
export var backButton = "_v-1";
export var pageContainer = "_v-2";
export var settingsContent = "_v-0";
export var sideNavContainer = "_v-6";
export var sideNavLink = "_v-7";
export var widgetContainer = "_v-5";
export var widgetSubsectionItem = "_v-3";
export var widgetSubsectionItemContent = "_v-4";